export enum EopResult {
  NotPassed = 'not passed',
  Extended = 'extended',
  Passed = 'passed',
}
